import React, {useCallback} from 'react';

import ExcelJS from 'exceljs';
import {saveAs} from 'file-saver';
import {useUserEmail} from 'src/hooks/useUserEmail';
import {printSheetHeader, printTableData, printTableDataHeader} from 'src/modules/attribute/download/print-data';
import {ExcelDownloadButton} from 'src/modules/downloads/components/excel-download-button';
import {getUserName} from 'src/modules/downloads/utils/get-user-name';
import {AttributeDetailInfo} from 'src/openapi/models/AttributeDetailInfo';
import {User} from 'src/openapi/models/User';

import {formatDate} from '@pb/kit-formatters';

type Props = {
    attributeName: string,
    attributes: Array<AttributeDetailInfo>,
    user: User | null,
};

export const AttributeExcelDownload = ({attributes, attributeName, user}: Props) => {
    const userEmail = useUserEmail();
    const userName = getUserName(userEmail, user);

    const onDownload = useCallback(async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Attribute', {views: [{showGridLines: false}]});

        printSheetHeader(worksheet, userName, attributeName);
        printTableDataHeader(worksheet);
        printTableData(worksheet, attributes);

        const buffer = await workbook.xlsx.writeBuffer();
        const date = formatDate(new Date(), 'YYYY_DD_MM_H_mm_ss');

        saveAs(new Blob([buffer]), `UD_Design_Tool_Attribute_${date}.xlsx`);
    }, [attributeName, attributes, userName]);

    return (
        <ExcelDownloadButton onDownload={onDownload}/>
    );
};
